import React from 'react';
import {API} from "aws-amplify";
import {toast} from "react-toastify";
import ReactDOM from 'react-dom';
import {ContentState, Editor, EditorState} from 'draft-js';

import InputCell from "@/common/form/InputCell";

export default function AddEditArticles(props){

    var {onDelete, onCancel, onSuccess, existingArticle, articleGroupId, articleId} = props;

    const [articleSwitch, setArticleSwitch] = React.useState(false);

    const onArticleSwitch = () => {
       setArticleSwitch(!articleSwitch)
    }

    const nameRef = React.useRef();
    const contentRef = React.useRef();

    const deleteArticle = () => {
        if(!existingArticle){
            return;
        }

        API.del('Core', '/api/v1/articles/' + articleGroupId + '/article/' + articleId)
            .then(response => {
                onDelete();
            },
                error =>{
                    toast("Could not delete article: " + error.response.data.message, {position: "top-center", type: "error"});
                });
    }

    const saveArticle = () => {
        const name = nameRef.current.value.trim();
        if (!name) {
            toast("Name cannot be empty.", {position: "top-center", type: "error"});
            return;
        }
        let article = {name, contents: contentRef.current.value};
        if(existingArticle){
            API.put('Core', '/api/v1/articles/' + articleGroupId + '/article/' + articleId, {body: article})
                .then(response => {
                        onSuccess(response);
                    },
                    error => {
                        toast("Could not update article: " + error.response.data.message, {position: "top-center", type: "error"});
                    }
                );
        }
        else{
            API.post('Core', '/api/v1/articles/' + articleGroupId + '/article', {body: article})
                .then(response => {
                        onSuccess(response);
                    },
                    error => {
                        toast("Could not create Article: " + error.response.data.message, {position: "top-center", type: "error"});
                    }
                );
        }
    }

    return (
        <div className="scrollView">
            <div className="content">
                <div className="tableView">
                    <div className="tableSection sectionName">
                        <p style={{ fontSize: '0.75em', color: 'var(--colorTitle)', marginBottom: '6px', marginTop: '-4px' }}>
                            Fields marked with <span style={{ color: 'red' }}>*</span> are required.
                        </p>
                        <InputCell
                            placeholder={"name..."}
                            defaultValue={(existingArticle ? existingArticle.name : "")}
                            required
                            id="articleName"
                            label="Name"
                            inputRef={nameRef}
                            disabled={existingArticle && existingArticle.libraryGroup.type !== "USER_CREATED"}
                            showRequiredIndicator
                            blurErrorMessage="Name cannot be empty."
                        />
                    </div>
                    <div className="tableSection sectionName">
                        <textarea rows="32" id="textArt"
                            placeholder={"Article contents"}
                            defaultValue={(existingArticle ? existingArticle.contents : "")}
                            ref={contentRef}
                        />
                    </div>
                </div>
            </div>
            <div className="actionBar">
                {
                    existingArticle ? (
                        <div className="actions left">
                            <div
                                onClick={deleteArticle}
                                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); deleteArticle(); } }}
                                className="button destructive medium"
                                role="button"
                                tabIndex={0}
                            >
                                <div className="title">Delete</div>
                            </div>
                        </div>
                    ) : null
                }
                <div className="actions">
                    {/*add functionality*/}
                    <div
                        onClick={onCancel}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onCancel(); } }}
                        className="button dismiss medium"
                        role="button"
                        tabIndex={0}
                    >
                        <div className="title">Cancel</div>
                    </div>

                    <div
                        onClick={saveArticle}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); saveArticle(); } }}
                        className={`button confirm medium`}
                        role="button"
                        tabIndex={0}
                    >
                        <div className="title">Done</div>
                    </div>
                </div>

                <div className="separator"></div>
            </div>
        </div>
    )
}
